import { render, staticRenderFns } from "./share-results.vue?vue&type=template&id=a7e03b76&scoped=true&"
import script from "./share-results.vue?vue&type=script&lang=ts&"
export * from "./share-results.vue?vue&type=script&lang=ts&"
import style0 from "./share-results.vue?vue&type=style&index=0&id=a7e03b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e03b76",
  null
  
)

export default component.exports